// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/StyleButtonFile.scss
// module id = 4266
// module chunks = 0